<template>
<nav :class="classes" v-show="length > 1">
  <a
    class="dn-pagination__item dn-pagination__prev"
    href="javascript:void(0);"
    v-if="value > 1"
    @click.prevent="onClickPrev"
  ><dn-icon icon="arrow-left" :class="{'is-disabled': disabled}" /></a>
  <a
    href="javascript:void(0);"
    v-for="n in items"
    :class="{'dn-pagination__item dn-pagination__number': true, 'dn-pagination__number--active': n === value}"
    v-if="!isNaN(n)"
    @click.prevent="onClickNumber(n)"
    v-text="n"
  ></a>
  <span class="dn-pagination__item dn-pagination__more" v-else v-text="n"></span>
  <a
    class="dn-pagination__item dn-pagination__next"
    href="javascript:void(0);"
    v-if="value !== length"
    @click.prevent="onClickNext"
  ><dn-icon icon="arrow-right" :class="{'is-disabled': disabled}" /></a>
</nav>
</template>



<script>



export default {
  props: {
    disabled: Boolean,
    length: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    },
  },



  data() {
    return {
    }
  },



  computed: {
    classes() {
      return {
        'dn-pagination': true,
        'dn-pagination--disabled': this.disabled,
      }
    },

    items() {
      if (this.length <= 5) return this.range(1, this.length);

      let min = this.value - 3;
      min = min > 0 ? min : 1;
      let max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) min = this.length - 6;

      const range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) range.splice(0, 2, 1, '…');

      if (this.value + 3 < this.length && this.length > 6) range.splice(range.length - 2, 2, '…', this.length);

      return range;
    },
  },



  methods: {
    set(index) {
      this.$emit('input', index);
    },

    next() {
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },

    prev() {
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },

    onClickNumber(index) {
      if (this.disabled) return false;
      this.set(index);
      this.$dn.blurActiveElement();
    },

    onClickPrev() {
      if (this.disabled) return false;
      this.prev();
      this.$dn.blurActiveElement();
    },

    onClickNext() {
      if (this.disabled) return false;
      this.next();
      this.$dn.blurActiveElement();
    },

    range(from, to) {
      const range = [];
      from = from > 0 ? from : 1;
      for (let i = from; i <= to; i++) {
        range.push(i);
      }
      return range;
    }
  },
}
</script>


// WEBPACK FOOTER //
// Pagination.vue?b4b83d02